import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'weatherIcon',
    standalone: false,
    pure: true
})
export class WeatherIconPipe implements PipeTransform {
  transform(conditions: string): string {
    if (!conditions) {return 'wb_sunny';}
    const lowerConditions = conditions.toLowerCase();
    if (lowerConditions.includes('rain')) {return 'water_drop';}
    if (lowerConditions.includes('snow')) {return 'ac_unit';}
    if (lowerConditions.includes('cloud')) {return 'cloud';}
    if (lowerConditions.includes('fog') || lowerConditions.includes('mist')) {return 'blur_on';}
    if (lowerConditions.includes('storm')) {return 'thunderstorm';}
    return 'wb_sunny';
  }
}
